import { HttpClient } from "../adapters/xhr/httpClient";

export function getAuthURL(url) {
    return HttpClient.POST(url, {
        headers: { "accept": "application/json" },
    })
        .then(({ data, status }) => { return { data, status } })
}

export function validateAuthCode(url, { code }) {
    return HttpClient.POST(url, {
        data: {
            code: code
        }
    }).then((res) => { return { data: res.data, status: res.status } })
}